import type { IconData } from '@stacksjs/iconify-core'

export const fastfood: IconData = {
  "body": "<path fill=\"currentColor\" d=\"M474.183 120H360V40h-32v80H200v32h17.92l6.154 48H112a80.09 80.09 0 0 0-80 80v16h280v-16a79.5 79.5 0 0 0-8-34.846a80.25 80.25 0 0 0-47.155-41.185L250.183 152h187.634l-35.9 280H32v32h398.08l40-312H496v-32ZM277.258 264H66.742A48.08 48.08 0 0 1 112 232h120a48.08 48.08 0 0 1 45.258 32\"/><path fill=\"currentColor\" d=\"M304 352h8v-32H32v32zm0 56h8v-32H32v32z\"/>",
  "width": 512,
  "height": 512,
  "viewBox": "0 0 512 512"
}

export default fastfood
